export default __webpack_public_path__ + "static/icon3-b801d74af12943b9a8f2b9d96f17885a.png";